import _ from 'lodash';
import Express from 'express';
import compress from 'compression';
import helmet from 'helmet';
import cors from 'cors';
import config from '~/config';

import * as stationId from './station-id';

const staticOpts = {
  dotfiles      : 'ignore',
  etag          : true,
  extensions    : false,
  fallthrough   : true,
  immutable     : false,
  index         : false,
  lastModified  : true,
  redirect      : true,
};

export function express( app ) {
  app.use( helmet() );
  app.use( cors() );
  app.use( compress() );
  app.use( Express.json() );
  app.use( Express.urlencoded( { extended : true } ) );
  app.use( Express.static( app.get( 'staticdir' ), staticOpts ) );
  app.use( Express.static( app.get( 'assetsdir' ), staticOpts ) );
  app.use( stationId.express );
}

export function feathers( app ) {
}

export function socketio( io ) {
  io.use( stationId.socket );
}
